module.exports = __webpack_public_path__ + "static/media/bt_top_homevisit_normal.fa0b74f5.png";